import { Outlet, useParams } from 'react-router-dom';
import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import Drawer from 'components/Drawer';
import BasicPageLayout from 'layouts/BasicPage';
import { ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER } from '../../constants';
import CreateEditExternalAutomationForm from './form';

type FormOpenMode = 'edit' | 'create';

const ExternalAutomationsPage = () => {
    const { agentId = '' } = useParams();
    const connectedAddModifyProps = useConnectModal(
        ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER,
        { size: 'small', slideFrom: 'right' },
    );

    const [, closeDrawer] = useOpenModal(ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER);
    const {
        mode,
        onCompleted,
        externalAutomationData = {},
        ...drawerProps
    } = connectedAddModifyProps;

    return (
        <BasicPageLayout>
            <Outlet />
            <Drawer
                {...drawerProps}
                onRequestClose={closeDrawer}
            >
                <CreateEditExternalAutomationForm
                    mode={mode as FormOpenMode}
                    agentId={agentId}
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    onCompleted={onCompleted}
                    onRequestClose={closeDrawer}
                    {...(externalAutomationData as object)}
                />
            </Drawer>
        </BasicPageLayout>
    );
};

export default ExternalAutomationsPage;
